import _ from "lodash";

import uuid from "uuid";

import { defaultIgnoredColumnCodes, requiredColumnsIdOrder, mainGroupFilterFields } from "../constants";

export const mapGenericGroupfilters = (group) => {
  const parsedFilters = group.filters;

  return {
    ...parsedFilters,
    id: group.id,
    name: group.name,
    description: group.description,

  };
};
export const mapItemsToUniqueValues = (items, key) => {
  const mapped = items.map((item) => item[key]);

  return _.uniq(mapped);
};

export const mapItemsToDropdownOptions = (items, key) => {
  if (key !== 'location_code_concatenation') {
    return mapItemsToUniqueValues(items, key)
      .filter((value) => !_.isNil(value))
      .map((value) => ({
        key: uuid.v4(),
        text: value,
        value: value,
      }));
  }
  //   if (groupType === 'event') {
  return mapItemsToUniqueValues(items, key)
    .filter((value) => !_.isNil(value))
    .map((value) => ({
      key: uuid.v4(),
      text: value + ' (' + items.filter(
        row => row.location_code_concatenation === value)[0].material_description + ')',
      value: value,
    }));


  //   }
};
export const mapMacroFiltersToMaterials = (newGroupData, items) => {
  if (Object.keys(newGroupData).length === 0) {
    return
  }
  const filtersContent = Object.fromEntries(
    Object.entries(newGroupData).filter(([groupProp, groupPropValue]) =>
    typeof (groupPropValue) !== 'object' || groupProp === 'rules' 
    || groupProp === 'location_code_concatenation'? false : true
    ))

  const isEveryMaterialSelected = (filtersContent) => {
    return Object.entries(filtersContent).every(
      ([, filtersContent]) => filtersContent.values.includes('all'))

  }
  if (isEveryMaterialSelected(filtersContent)) {
    return items.map(item => item.location_code_concatenation)
  }
  const macrofilters = Object.fromEntries(
    Object.entries(filtersContent).filter(
      ([, filterContent]) => !filterContent.values.includes('all')))

  const isIncludedByMacrofilters = (macrofilters, item) => {
    return Object.entries(macrofilters).every(([filterName, filter])=>
    filter.values.includes(item[filterName]))
  }



  const correspondingFilteredMaterials = items.filter(
    item => isIncludedByMacrofilters(macrofilters, item))
  return correspondingFilteredMaterials.length !== 0 ?
    correspondingFilteredMaterials.map(item => item.location_code_concatenation) : null

}

export const mapColumnsToGroupFields = (t, columns, items) => {
  const groupFields = [];
  let ignoredColumnCodes = [...defaultIgnoredColumnCodes]
  let filteringFields = []
  //   if (groupType === 'conventional') {
  filteringFields = ["material_location", "material_unitof_measure", "material_type", "location_code_concatenation"]
  if (items.length !== 0) {
    // adding columns read from orders table
    const expectedFieldsFromItems = ["supply_lead_time_category", "variability_category"]
    expectedFieldsFromItems.forEach(field => {
      if (Object.keys(items[0]).includes(field)) {
        filteringFields.push(field)
        columns[field] = field
      }
    })
  }
  ignoredColumnCodes.splice(ignoredColumnCodes.indexOf('location_code_concatenation'), 1)

  if (!_.isEmpty(columns)) {
    groupFields.push(
      ...Object.keys(columns)
        .filter((key) => !_.includes(ignoredColumnCodes, key))
        .map((key) => ({
          name: _.includes(
            filteringFields,
            key
          )
            ? t(`ordersTable.columns.${key}`)
            : columns[key],
          accessor: key,
          options: mapItemsToDropdownOptions(items, key),
        }))
    );
  }

  return groupFields;
};

export const mapColsToAdditionalFields = (columns) => {
  return Object.keys(columns).filter(field => !requiredColumnsIdOrder.includes(field))

}

export const fatherItems = (fatherGroup, items, columns) => {
  if (fatherGroup == null) {
    return items
  }
  const additionalColsFields = mapColsToAdditionalFields(columns)
  const includeFields = [...mainGroupFilterFields, ...additionalColsFields]
  const fatherFilters = Object.entries(fatherGroup).filter(
    (filterField) => includeFields.includes(filterField[0])).filter(
      (filterField) => !filterField[1].values.includes("all"));

  let filteredItems = []


  const filterItems = () => {
    items.forEach(item => {
      const itemBelongsToFatherFilter = (item, fatherFilter) => {
        return (fatherFilter[1].values.includes(item[fatherFilter[0]]))
      }
      let fulfillsFiltersCriteria = []
      fatherFilters.forEach(fatherFilter => {
        fulfillsFiltersCriteria.push(itemBelongsToFatherFilter(item, fatherFilter))
      })
      if (fulfillsFiltersCriteria.every(filterOcurrance => filterOcurrance === true)) {
        filteredItems.push(item)
      }
    })
  }
  filterItems()
  return filteredItems
}